import { render, staticRenderFns } from "./calendar-header.vue?vue&type=template&id=6966c450&"
import script from "./calendar-header.vue?vue&type=script&lang=js&"
export * from "./calendar-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports